import React from 'react';
import { getCurrencyBadgeClasses, normalizeCurrency, CURRENCY_META } from '../utils/currencyStyles';

const CurrencyBadge = ({ currency = 'ARS', modoOscuro = false, size = 'sm', className = '' }) => {
  const c = normalizeCurrency(currency);
  const meta = CURRENCY_META[c];
  const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-[11px] px-2 py-0.5';

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold border shrink-0 ${sizeClass} ${getCurrencyBadgeClasses(c, modoOscuro)} ${className}`}
      title={meta.label}
    >
      {c}
    </span>
  );
};

export default CurrencyBadge;
